var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfficeSpace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#C8DCE8",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47266 12.1595H17.5085V24.7306H7.47266V12.1595ZM12.4906 6.26904V11.2616H18.2254V24.7306H22.5264V6.26904H12.4906ZM14.5876 7.70787H16.6772V9.78688H14.5876V7.70787ZM18.3399 7.70787H20.4295V9.78688H18.3399V7.70787ZM9.56965 14.0652V16.1442H11.6593V14.0652H9.56965ZM13.322 14.0652V16.1442H15.4116V14.0652H13.322ZM9.56965 17.4055V19.4846H11.6593V17.4055H9.56965ZM9.56965 20.7459V22.8249H11.6593V20.7459H9.56965ZM13.322 17.4055V19.4846H15.4116V17.4055H13.322ZM13.322 20.7459V22.8249H15.4116V20.7459H13.322Z",
    fill: "#C8DCE8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeSpace);
export default __webpack_public_path__ + "static/media/Office-space.2cdb52dd.svg";
export { ForwardRef as ReactComponent };